import {
	ContentWrap,
	Css,
	ILinkItemType,
	IResponsiveImageSource,
	IStyledHighlightProps,
	Responsive,
	StyledHighlight,
} from '@/ui';
import styled from '@emotion/styled';
import { HighlightImage } from './HighlightImage';
import { HighlightContent, IHighlightContentProps } from './HighlightContent';
import { Color } from '../../../styles/Color';

export interface IHighlight
	extends IStyledHighlightProps,
		IHighlightContentProps {
	imageSource?: IResponsiveImageSource;
	imageAlt?: string;
	linkType?: ILinkItemType;
}

export default function Highlight({
	orientation,
	imageSource,
	imageAlt,
	title,
	body,
	linkHref,
	linkTitle,
	imagePosition,
	linkType,
}: IHighlight) {
	return (
		<StyledSection>
			<StyledContentWrap>
				<StyledHighlightWrap
					imagePosition={imagePosition}
					orientation={orientation}
				>
					{imageSource && (
						<StyledHighlightImage imagePosition={imagePosition}>
							<HighlightImage source={imageSource} alt={imageAlt} />
						</StyledHighlightImage>
					)}
					<HighlightContent
						title={title}
						body={body}
						linkHref={linkHref}
						linkTitle={linkTitle}
						imagePosition={imagePosition}
						linkType={linkType}
					/>
				</StyledHighlightWrap>
			</StyledContentWrap>
		</StyledSection>
	);
}

const StyledSection = styled.section`
	background-color: ${Color.Neutral94};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		&:first-child {
			margin: ${Css.pxToRemFromTheme(32)} 0 0 0;
		}
	}
`;

const StyledContentWrap = styled(ContentWrap)`
	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin: 0;
	}
`;

const StyledHighlightWrap = styled(StyledHighlight)`
	display: grid;
	grid-template-columns: 1fr ${Css.pxToRemFromTheme(80)} 1fr;
	padding: ${Css.pxToRemFromTheme(32)} 0;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: flex;
		padding: 0;
	}
`;

const StyledHighlightImage = styled.div<{
	imagePosition: IHighlight['imagePosition'];
}>`
	position: relative;
	grid-row: 1;
	grid-column: ${({ imagePosition }) => {
		if (imagePosition && imagePosition[0] === 'first') return '1 / span 2';
		return '2 / span 3';
	}};
	display: grid;
	grid-template-columns: ${({ imagePosition }) => {
		if (imagePosition && imagePosition[0] === 'first')
			return `1fr ${Css.pxToRem(240)} ${Css.pxToRem(112)}`;
		return `${Css.pxToRem(112)} ${Css.pxToRem(240)} 1fr`;
	}};
	overflow: hidden;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		grid-column: 1;
		grid-row: 1 / span 2;

		grid-template-rows: 1fr ${Css.pxToRem(112)};
		grid-template-columns: ${Css.pxToRem(16)} ${Css.pxToRem(240)} 1fr;
	}
`;
